import { ItemCard } from "@coworker/apprestructured/src/shared/components/item-cards/ItemCard/ItemCard";
import styles from "@coworker/apprestructured/src/media-maintenance/styles/common-media-styles.module.css";
import { ItemName } from "@coworker/apprestructured/src/shared/components/item-cards/ItemName/ItemName";
import { ItemNoWithCopy } from "@coworker/apprestructured/src/shared/components/item-cards/ItemNoWithCopy/ItemNoWithCopy";
import React from "react";
import { ItemImageLocalCombination } from "@coworker/apprestructured/src/media-maintenance/components/item-cards/ItemImageLocalCombination/ItemImageLocalCombination";
import { Article } from "@coworker/app/src/components/RoomSettings/types/article";
import { AggregatedArticle } from "@coworker/app/src/components/RoomSettings/hooks/useAggregatedArticles";
import { formatProductIdWithDots } from "@coworker/reusable/formatters/product.formatter";
import { ItemNo } from "@coworker/apprestructured/src/shared/components/item-cards/ItemNo/ItemNo";

interface MediaItemCardLocalCombinationBasicProps {
  article: Article | AggregatedArticle;
  canCopyItemNo?: boolean;
}

export const MediaItemCardLocalCombinationBasic = ({
  article,
  canCopyItemNo = true,
}: MediaItemCardLocalCombinationBasicProps) => {
  return (
    <ItemCard dataTestId={"media-item-card-local-combination-basic"}>
      <div className={styles["item-card-root-row"]}>
        <ItemImageLocalCombination />
        <div className={styles["item-card-root-column"]}>
          <ItemName name={article.itemName} />
          {canCopyItemNo ? (
            <ItemNoWithCopy
              itemNo={formatProductIdWithDots(article.productArticleId)}
            />
          ) : (
            <ItemNo
              itemNo={formatProductIdWithDots(article.productArticleId)}
            />
          )}
        </div>
      </div>
    </ItemCard>
  );
};
